import { ImageProps as ImageType } from 'components/atoms/Image';
import { ExerciseActionType } from './exercises.actionCreators';
import { PRESELECT_EXERCISE, REQUEST_EXERCISES_SUCCESS } from './exercises.actionTypes';

export type ExerciseType = {
	title: string;
	met: number;
	overrideImage?: ImageType;
	contentType: string;
	externalId: string;
};

export type ExercisesStateType = {
	readonly index: ExerciseType[];
	readonly error: null | boolean;
	readonly preselectedExerciseIdsPerWorkout: { [key: string]: string };
	readonly byExternalId?: { [key: string]: ExerciseType };
};

export type RootStateType = {
	exercises: ExercisesStateType;
};

// Reducer
// ------------------------------------

export const initialState: ExercisesStateType = {
	index: [],
	error: null,
	preselectedExerciseIdsPerWorkout: {},
};

export default (state: ExercisesStateType = initialState, action: ExerciseActionType): ExercisesStateType => {
	switch (action.type) {
		case REQUEST_EXERCISES_SUCCESS:
			return {
				...state,
				index: action.exercises,
				byExternalId: {
					...state.byExternalId,
					...action.exercises.reduce((acc, exercise) => {
						acc[exercise.externalId] = {
							...exercise,
						};
						return acc;
					}, {}),
				},
			};
		case PRESELECT_EXERCISE:
			const _action = action;
			return {
				...state,
				preselectedExerciseIdsPerWorkout: {
					...state.preselectedExerciseIdsPerWorkout,
					[_action.workoutId]: _action.exerciseId,
				},
			};
		default:
			return state;
	}
};
